import { CANDY_APPLE, OLAF, OZ, SORBET } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { CallWidgetStates } from 'calling-internal-common/widget-status/constants/CallWidgetStates';
import { jsx as _jsx } from "react/jsx-runtime";
const CallStatusIcon = ({
  callStatus,
  isError
}) => {
  const isAnswered = callStatus === CallWidgetStates.ANSWERED;
  const name = isError ? 'remove' : isAnswered ? 'success' : 'ellipses';
  const backgroundColor = isError ? CANDY_APPLE : isAnswered ? OZ : SORBET;
  return /*#__PURE__*/_jsx(UIIconCircle, {
    name: name,
    size: 8,
    borderWidth: 0,
    backgroundColor: backgroundColor,
    color: OLAF,
    verticalAlign: "top",
    innerStyles: {
      transform: 'scale(1.7)',
      transformOrigin: 'center'
    }
  });
};
export default CallStatusIcon;